import type { CustomAlertPayload } from "../../../modules/alerts/custom/types";
import type { NetworkPayload } from "../../../../composites";

const resourceUrl = "saved_searches";

export const customAlertAPI = {
  saveAlert: (
    payload: CustomAlertPayload,
  ): NetworkPayload<CustomAlertPayload> => {
    return {
      url: `${resourceUrl}/`,
      options: {
        method: "POST",
        payload,
        isJsonResponse: true,
      },
    };
  },
  deleteAlert: (savedSearchId: API.SavedSearchId): NetworkPayload => {
    return {
      url: `${resourceUrl}/${savedSearchId}/`,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    };
  },
  getAlerts: (): NetworkPayload => {
    return {
      url: `${resourceUrl}/`,
      options: {
        method: "GET",
        isJsonResponse: true,
      },
    };
  },
};
